import { Form, Select } from 'antd'
import { useEffect, useRef } from 'react'
import PatientList from './PatientList'
import PatientSearch from './PatientSearch'
import PatientCreate from './PatientCreate'
import PatientEdit from './PatientEdit'
import PatientDependents from './PatientDependents'
import AppointmentSearch from './AppointmentSearch'
import AppointmentAvailable from './AppointmentAvailable'
import AppointmentCreate from './AppointmentCreate'
import AppointmentCancel from './AppointmentCancel'
import AppointmentReschedule from './AppointmentReschedule'
import AppointmentStatus from './AppointmentStatus'
import AppointmentPrice from './AppointmentPrice'
import ProfessionalList from './ProfessionalList'
import ProfessionalSearch from './ProfessionalSearch'
import ProfessionalInsurance from './ProfessionalInsurance'

const actionOptions = [
  {
    label: 'Pacientes',
    options: [
      { label: 'Listar Pacientes', value: 'PATIENT_LIST' },
      { label: 'Buscar Paciente', value: 'PATIENT_SEARCH' },
      { label: 'Criar Paciente', value: 'PATIENT_CREATE' },
      { label: 'Editar Paciente', value: 'PATIENT_EDIT' },
      { label: 'Listar Origens de Pacientes', value: 'PATIENT_SOURCES' },
      { label: 'Listar Dependentes', value: 'PATIENT_DEPENDENTS' },
    ],
  },
  {
    label: 'Agendamentos',
    options: [
      { label: 'Buscar Agendamentos', value: 'APPOINTMENT_SEARCH' },
      { label: 'Horários Disponíveis', value: 'APPOINTMENT_AVAILABLE' },
      { label: 'Criar Agendamento', value: 'APPOINTMENT_CREATE' },
      { label: 'Cancelar Agendamento', value: 'APPOINTMENT_CANCEL' },
      { label: 'Reagendar Agendamento', value: 'APPOINTMENT_RESCHEDULE' },
      { label: 'Atualizar Status do Agendamento', value: 'APPOINTMENT_STATUS' },
      { label: 'Consultar Preço', value: 'APPOINTMENT_PRICE' },
      { label: 'Listar Status', value: 'APPOINTMENT_STATUSES' },
      { label: 'Listar Canais', value: 'APPOINTMENT_CHANNELS' },
      { label: 'Listar Motivos de Cancelamento', value: 'APPOINTMENT_MOTIVES' },
    ],
  },
  {
    label: 'Convênios e Especialidades',
    options: [
      { label: 'Listar Convênios', value: 'INSURANCE_LIST' },
      { label: 'Listar Especialidades', value: 'SPECIALTY_LIST' },
    ],
  },
  {
    label: 'Profissionais',
    options: [
      { label: 'Listar Profissionais', value: 'PROFESSIONAL_LIST' },
      { label: 'Buscar Profissional', value: 'PROFESSIONAL_SEARCH' },
      { label: 'Convênios do Profissional', value: 'PROFESSIONAL_INSURANCE' },
    ],
  },
]

export default function FeegowForm({ form, fieldName, parameters }) {
  const type = Form.useWatch(['actions', fieldName, 'action', 'type'], form)
  const prevTypeRef = useRef(undefined)

  useEffect(() => {
    if (prevTypeRef.current !== undefined && prevTypeRef.current !== type) {
      form.setFieldValue(['actions', fieldName, 'action', 'data'], undefined)
    }
    prevTypeRef.current = type
  }, [type, form, fieldName])

  return (
    <>
      <Form.Item label="Tipo de ação" name={[fieldName, 'action', 'type']}>
        <Select
          options={actionOptions}
          placeholder="Selecione o tipo de ação"
          showSearch
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
        />
      </Form.Item>

      {type === 'PATIENT_LIST' && (
        <PatientList fieldName={fieldName} parameters={parameters} />
      )}
      {type === 'PATIENT_SEARCH' && (
        <PatientSearch fieldName={fieldName} parameters={parameters} />
      )}
      {type === 'PATIENT_CREATE' && (
        <PatientCreate fieldName={fieldName} parameters={parameters} />
      )}
      {type === 'PATIENT_EDIT' && (
        <PatientEdit fieldName={fieldName} parameters={parameters} />
      )}
      {type === 'PATIENT_DEPENDENTS' && (
        <PatientDependents fieldName={fieldName} parameters={parameters} />
      )}
      {type === 'APPOINTMENT_SEARCH' && (
        <AppointmentSearch fieldName={fieldName} parameters={parameters} />
      )}
      {type === 'APPOINTMENT_AVAILABLE' && (
        <AppointmentAvailable fieldName={fieldName} parameters={parameters} />
      )}
      {type === 'APPOINTMENT_CREATE' && (
        <AppointmentCreate fieldName={fieldName} parameters={parameters} />
      )}
      {type === 'APPOINTMENT_CANCEL' && (
        <AppointmentCancel fieldName={fieldName} parameters={parameters} />
      )}
      {type === 'APPOINTMENT_RESCHEDULE' && (
        <AppointmentReschedule fieldName={fieldName} parameters={parameters} />
      )}
      {type === 'APPOINTMENT_STATUS' && (
        <AppointmentStatus fieldName={fieldName} parameters={parameters} />
      )}
      {type === 'APPOINTMENT_PRICE' && (
        <AppointmentPrice fieldName={fieldName} parameters={parameters} />
      )}
      {type === 'PROFESSIONAL_LIST' && (
        <ProfessionalList fieldName={fieldName} parameters={parameters} />
      )}
      {type === 'PROFESSIONAL_SEARCH' && (
        <ProfessionalSearch fieldName={fieldName} parameters={parameters} />
      )}
      {type === 'PROFESSIONAL_INSURANCE' && (
        <ProfessionalInsurance fieldName={fieldName} parameters={parameters} />
      )}
    </>
  )
}
